import { useMemo, useState } from "react";
import Form from "V2.0/components/Form";
import Joi from "joi-browser";
import { message } from "antd";
import { getTransferAgentByAssistant } from "./getTransferAgentByAssistant";
import { ASSISTANT } from "../Assistant";

function TransferAgentForm(props) {
  const {
    defaultTransferAgent,
    assistantType,
    onSubmit,
    onCancel,
    loading,
    setLoading,
    buttonInfo,
    availableSlotTags,
  } = props;

  const { template, schema, inputField } = getTransferAgentByAssistant(
    assistantType,
    defaultTransferAgent
  );

  const updatedTemplate = useMemo(() => {
    if (assistantType === ASSISTANT.VOICE) {
      const slotTagTemplateIdx = template.findIndex(
        (fieldTemplate) => fieldTemplate.name === "slotTag"
      );
      const slotTagTemplate = template[slotTagTemplateIdx];

      const updatedSlotTagTemplate = {
        ...slotTagTemplate,
        options: [
          ...slotTagTemplate.options,
          ...availableSlotTags.map((slotTag, idx) => {
            return { id: idx + 1, value: slotTag, label: slotTag };
          }),
        ],
      };

      return template.toSpliced(slotTagTemplateIdx, 1, updatedSlotTagTemplate);
    }

    return template;
  }, [availableSlotTags, assistantType, template]);

  return (
    <Form
      template={updatedTemplate}
      schema={schema}
      inputField={inputField}
      onSubmit={onSubmit}
      handleSecondary={onCancel}
      loading={loading}
      setLoading={setLoading}
      buttonInfo={buttonInfo}
    />
  );
}

export { TransferAgentForm };
